 // Helper to check if a node has children
 export default function hasChildren(node) {
    return node.children && node.children.length > 0;
};
  